export const DEMAT_MODAL_KEY = {
  OtpSend: "OTP will be sent on this number",
  termsText:"I have read, understood, and hereby accept the Privacy Policy",
  termsLink: "Terms of use.",
  enterMobileNumber: "Please enter your mobile number",
  invalidMobileNumber: "Please enter a valid 10-digit mobile number",
  invalidMobileNumberFormat: "Please enter the valid mobile number",
  enterOtp: "Please enter the complete 4-digit OTP",
};

export const BFSL_PWA_BASE_URL = "https://pwa.bajajfinservsecurities.in/";

export const BFSL_PWA_URL =
  "https://pwa.bajajfinservsecurities.in/?sso-module=bfsl";

/** Default utm_source when AEM-authored values are absent. */
export const DEFAULT_UTM_SOURCE_APP = "widget";
export const DEFAULT_UTM_SOURCE_WEB = "widget";
